import { useTranslation } from 'react-i18next'

import { ArrowUDownLeftIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Card, CardTitle, SegmentedControls } from '@reveni-io/reveni-ui'

import CardDescription from '@/metrics/components/CardDescription/CardDescription'
import { getMetricsDimensionTabOptions } from '@/metrics/helpers/helpers'

import useReturnSalesRatioTabs from './hooks/useReturnSalesRatioTabs/useReturnSalesRatioTabs'
import ReturnSalesRatioContent from './ReturnSalesRatioContent/ReturnSalesRatioContent'
import * as Styles from './styles'

const ReturnSalesRatioCard = ({
  data,
  filters,
  loading,
  salesOrdersDataActivated,
  setChartFilters,
  showDescription,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { selectedTab, setSelectedTab, metrics, description } = useReturnSalesRatioTabs()

  if (!salesOrdersDataActivated) return null

  return (
    <Card showBorder={false}>
      <CardTitle marginBottom={showDescription ? theme.spacing.sp16 : theme.spacing.sp32}>
        <Styles.Title>
          <ArrowUDownLeftIcon size={24} />
          {t('Tasa de devoluciones/ventas')}
        </Styles.Title>
        <SegmentedControls options={getMetricsDimensionTabOptions(t)} value={selectedTab} onChange={setSelectedTab} />
      </CardTitle>
      {showDescription && <CardDescription>{t(description)}</CardDescription>}
      <ReturnSalesRatioContent
        data={data}
        metrics={metrics}
        filters={filters}
        loading={loading}
        setChartFilters={setChartFilters}
      />
    </Card>
  )
}

export default ReturnSalesRatioCard
